import { Injectable, OnDestroy } from "@angular/core";
import { TreeService } from "@mydocma/component-library/src/lib/tree";
import { MediatorService } from "@mydocma/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { BehaviorSubject, Subject } from "rxjs";

export enum CoEvent {
    StructureTreeReady,

    PlanCreated,
    PlanDeleted,
    PlanUpdated,

    BimModelCreated,
    BimModelDeleted,
    BimModelUpdated
}


@UntilDestroy()
@Injectable({providedIn: 'root'})
export class CoEventService implements OnDestroy {

    private projectStructureTreeReadySubject = new BehaviorSubject<TreeService>(null);
    public onProjectStructureTreeReady = this.projectStructureTreeReadySubject.asObservable();

    private planCreatedSubject = new Subject<any>();
    private planDeletedSubject = new Subject<any>();
    private planUpdatedSubject = new Subject<any>();
    public onPlanCreated = this.planCreatedSubject.asObservable();
    public onPlanDeleted = this.planDeletedSubject.asObservable();
    public onPlanUpdated = this.planUpdatedSubject.asObservable();

    private bimModelCreatedSubject = new Subject<any>();
    private bimModelDeletedSubject = new Subject<any>();
    private bimModelUpdatedSubject = new Subject<any>();
    public onBimModelCreated = this.bimModelCreatedSubject.asObservable();
    public onBimModelDeleted = this.bimModelDeletedSubject.asObservable();
    public onBimModelUpdated = this.bimModelUpdatedSubject.asObservable();

    constructor(private readonly mediatorService: MediatorService) {
      this.mediatorService.subscribe('structure-tree-ready', 'bp-event-service', (treeService) => {
        this.projectStructureTreeReadySubject.next(treeService);
      });
    }

    public emit(eventType: CoEvent, data: any) {
        switch(eventType) {
            case CoEvent.PlanCreated:
                this.planCreatedSubject.next(data);
                break;
            case CoEvent.PlanDeleted:
                this.planDeletedSubject.next(data);
                break;
            case CoEvent.PlanUpdated:
                this.planUpdatedSubject.next(data);
                break;
            case CoEvent.BimModelCreated:
                this.bimModelCreatedSubject.next(data);
                break;
            case CoEvent.BimModelDeleted:
                this.bimModelDeletedSubject.next(data);
                break;
            case CoEvent.BimModelUpdated:
                this.bimModelUpdatedSubject.next(data);
                break;
            case CoEvent.StructureTreeReady:
                this.projectStructureTreeReadySubject.next(data);
                break;
            default:
        }
    }

    ngOnDestroy(): void {}
}
